import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Switch, Route, useParams, Redirect, useLocation } from 'react-router-dom';
import Loading from '../components/loading';
import OfferPage from '../components/offer';
import OfferPlanSelect from '../components/offer/plan-select';
import ThankYouPage from '../components/offer/thank-you';
import PageNotFound from '../components/page-not-found';
import SettingUp from '../components/offer/setting-up/index';
import { useAbandonedCart } from '../components/shared/hooks';
import { setHeaderProductName } from '../lib/aui-header';
import { checkIsAuthenticated } from '../lib/helpers';
import { getLoginFromUrl } from '../lib/side-effects';
import { getSystemErrorMessaging } from '../lib/side-effects/error';
import { fetchOffer } from '../lib/side-effects/offers';
import { initializeOfferProgressBar } from '../lib/side-effects/progress-bar';
import { configureFeatures } from '../lib/side-effects/features';
import { selectState } from '../selectors';
import { shouldRedirectToLogin } from '../selectors/offer';
import { getSelectedPlan } from '../selectors/order';
import { removeAvalaraPrefix } from '../../shared/helpers';
import { Pages } from '../../shared/types/offers';
const OfferContainer = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const { requestedOfferFlow } = useParams();
    const state = useSelector(selectState);
    const [shouldBlockFreeTrial, setShouldBlockFreeTrial] = useState(false);
    const { account: { isLoggedIn }, features, offer: { fetchStatus, offerFlow, offerName, pages, plans, }, order: { planSelectComplete }, } = state;
    const selectedPlan = useSelector(getSelectedPlan);
    useEffect(() => {
        if (fetchStatus === 'SUCCESS')
            getLoginFromUrl();
    }, [location.search, fetchStatus]);
    const authRedirectPending = useSelector(shouldRedirectToLogin);
    useEffect(() => {
        if (requestedOfferFlow)
            dispatch(fetchOffer(requestedOfferFlow));
    }, [requestedOfferFlow]);
    useEffect(() => {
        dispatch(configureFeatures(location.search));
    }, [location.search]);
    useEffect(() => {
        if (requestedOfferFlow === 'free-trial') {
            const isFeatureLoaded = features.enableGenesisFreeTrial !== undefined ||
                features.ENABLEGENESISFREETRIAL !== undefined;
            if (isFeatureLoaded) {
                const hasQueryParam = /a1F9xY7pQ3tV0LzW8rKd5Jc2hBnSmE4o=true/i.test(location.search);
                const isFeatureEnabled = features.enableGenesisFreeTrial || features.ENABLEGENESISFREETRIAL;
                setShouldBlockFreeTrial(!hasQueryParam && !isFeatureEnabled);
            }
        }
    }, [requestedOfferFlow, features, location.search]);
    useEffect(() => {
        if (offerFlow)
            dispatch(initializeOfferProgressBar());
    }, [isLoggedIn, offerFlow, selectedPlan]);
    useEffect(() => {
        if (offerName)
            setHeaderProductName(removeAvalaraPrefix(offerName));
    }, [offerName]);
    useAbandonedCart(true);
    const isAccountFetchInProgress = checkIsAuthenticated() && !isLoggedIn;
    const isIneligible = fetchStatus === 'SUCCESS' && plans.length === 0;
    useEffect(() => {
        if (!isIneligible || authRedirectPending || isAccountFetchInProgress)
            return;
        const errorCode = 'defaultIneligibility';
        dispatch(getSystemErrorMessaging({ errorCode, offerName }));
    }, [isIneligible, authRedirectPending, offerFlow, isAccountFetchInProgress]);
    if (Object.keys(features).length === 0) {
        return React.createElement(Loading, null);
    }
    if (shouldBlockFreeTrial) {
        return React.createElement(PageNotFound, null);
    }
    if (fetchStatus === 'PENDING' || isIneligible)
        return null;
    if (fetchStatus === 'NOT_FOUND' || !offerFlow)
        return React.createElement(PageNotFound, null);
    if (authRedirectPending)
        return React.createElement(Loading, null);
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: `/${offerFlow}`, component: OfferPlanSelect }),
        !planSelectComplete &&
            React.createElement(Route, { path: `/${offerFlow}` },
                React.createElement(Redirect, { to: { pathname: `/${offerFlow}`, search: window.location.search } })),
        pages.includes(Pages.SettingUp) &&
            React.createElement(Route, { path: `/${offerFlow}/setting-up`, component: SettingUp }),
        React.createElement(Route, { path: `/${offerFlow}/thank-you`, component: ThankYouPage }),
        React.createElement(Route, { component: OfferPage })));
};
export default OfferContainer;
